export const buildTanMasterPayload = (
  formData,
  selectedEntity,
  isEdit = false,
  isTanActive = true
) => {  
  return {
    entityUuid: selectedEntity,
    entityName: formData.entityName,
    entityType: formData.entityType,
    permanentAccountNumber: formData.permanentAccountNumber,
    taxDeductionAccountNumber: formData.taxDeductionAccountNumber,
    branchDivision: formData.branchDivision,
    country: formData.country || 'INDIA',
    flatDoorBlockNumber: formData.flatDoorBlockNumber,
    nameOfPremisesBuilding: formData.nameOfPremisesBuilding,
    roadStreetLane: formData.roadStreetLane,
    areaLocality: formData.areaLocality,
    townDistrictCity: formData.townDistrictCity,
    state: formData.state,
    stateName: formData.stateMinistry,
    pinCode: formData.pinCode,
    stdCode: formData.stdCode,
    telephoneNumber: formData.telephoneNumber,
    stdCodeAlternative: formData.stdCodeAlternate,
    telephoneNumberAlternative: formData.telephoneNumberAlternative,
    entityEmailId: formData.entityEmailId,
    entityEmailIdAlternative: formData.entityEmailIdAlternative,
    gstnNumber: formData.gstnNumber,
    paoCode: formData.paoCode,
    poaRegistration: formData.paoRegistrationNumber,
    ddoCode: formData.ddoCode,
    ddoRegistrationNumber: formData.ddoRegistrationNumber,
    ministryName: formData.ministryName,
    ...(formData.ministryName === 'OTHERS' && {
      ministryNameOther: formData.ministryNameOther,
    }),
    ainNumber: formData.ainNumber,
    active: isTanActive,

    responsiblePersonDetailsRequestDTO: {
      nameOfResponsiblePerson: formData.nameOfResponsiblePerson,
      pan: formData.pan,
      flatDoorBlockNumber: formData.flatDoorBlockNumberRP,
      state: formData.stateRP,
      pincode: formData.pinCodeRP,
      responsibleMobileNumber: formData.responsibleMobileNumber,
      nameOfPremises: formData.nameOfPremisesBuildingRP,
      roadStreetLane: formData.roadStreetLaneRP,
      areaLocality: formData.areaLocalityRP,

      townDistrictCity: formData.townDistrictCityRP,
      stdCode: formData.stdCodeRP,
      telephoneNumber: formData.telephoneNoRP,
      stdCodeAlternative: formData.stdCodeAlternateRP,
      telephoneNumberAlternative: formData.telephoneNoAlternateRP,
      email: formData.emailRP,
      emailAlternative: formData.emailAlternateRP,
      // Add only when editing
      ...(isEdit && { tanMasterUuid: formData.tanMasterUuid }),
      designation: formData.designation,
    },
  }
}
